import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../../Helper/ToastMessage";

// Get Table Data
export const ChemicalSupplyTableDataAPI = createAsyncThunk("ChemicalSupplyTableData", async ({ data }) => {
    const {
        FromDate,
        ToDate,
        M_WardID,
        M_WS_JunctionID,
        M_UserID,
        Flag,
        token,
        From,
        To,
        DashProjectTypeId,
        RoleID,
        handleChemicalSupplyExport
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    let url

    if (DashProjectTypeId == 6 && RoleID != '16') {
        url = `${BaseUrl}/APKDashboard/Get_WEB_WS_T_Distri_WaterChemicalSupply_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '0'}&M_Distri_WS_LocationID=${M_WS_JunctionID ? M_WS_JunctionID : '0'}&M_UserID=${M_UserID}&Flag=${Flag}&From=${From}&To=${To}`
    } else {
        url = `${BaseUrl}/APKDashboard/Get_WEB_WS_T_WS_ChemicalSupply_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '0'}&M_WS_JunctionID=${M_WS_JunctionID ? M_WS_JunctionID : '0'}&M_UserID=${M_UserID}&Flag=${Flag}&From=${From}&To=${To}`
    }
    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleChemicalSupplyExport && handleChemicalSupplyExport()
                return result.data
            } else {
                return result
            }
        })
})

const ChemicalSupplyTableDataSlice = createSlice({
    name: "ChemicalSupplyTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ChemicalSupplyTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(ChemicalSupplyTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(ChemicalSupplyTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const ChemicalSupplyTableDataReducer = ChemicalSupplyTableDataSlice.reducer

export const ChemicalSupplyExportTableDataAPI = createAsyncThunk("ChemicalSupplyExportTableData", async ({ data }) => {
    const {
        FromDate,
        ToDate,
        M_WardID,
        M_WS_JunctionID,
        M_UserID,
        Flag,
        token,
        From,
        To,
        DashProjectTypeId,
        RoleID
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    let url
    if (DashProjectTypeId == 6 && RoleID != '16') {
        url = `${BaseUrl}/APKDashboard/Get_WEB_WS_T_Distri_WaterChemicalSupply_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '0'}&M_Distri_WS_LocationID=${M_WS_JunctionID ? M_WS_JunctionID : '0'}&M_UserID=${M_UserID}&Flag=${Flag}&From=${From}&To=${To}`
    } else {
        url = `${BaseUrl}/APKDashboard/Get_WEB_WS_T_WS_ChemicalSupply_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '0'}&M_WS_JunctionID=${M_WS_JunctionID ? M_WS_JunctionID : '0'}&M_UserID=${M_UserID}&Flag=${Flag}&From=${From}&To=${To}`
    }
    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const ChemicalSupplyExportTableDataSlice = createSlice({
    name: "ChemicalSupplyTableData",
    initialState: {
        isExportLoading: false,
        ExportTableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ChemicalSupplyExportTableDataAPI.pending, (state, action) => {
            state.isExportLoading = true;
        });
        builder.addCase(ChemicalSupplyExportTableDataAPI.fulfilled, (state, action) => {
            state.isExportLoading = false;
            state.ExportTableData = action.payload;
        });
        builder.addCase(ChemicalSupplyExportTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isExportLoading = false;
            state.isError = true;
            state.ExportTableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const ChemicalSupplyExportTableDataReducer = ChemicalSupplyExportTableDataSlice.reducer



export const ChemicalSupplyPostDataAPI = createAsyncThunk("ChemicalSupplyPostData", async ({ data }) => {
    const {
        T_WS_ChemicalSupplyID,
        T_Distri_WaterChemicalSupplyID,
        WaterReading,
        Chroline,
        M_UserID,
        token,
        Flag,
        handleIsPost,
        handleClearField,
        handleOnCloseClick,
        DashProjectTypeId,
        RoleID
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();

    if (DashProjectTypeId == '6' && RoleID != '16') {
        formdata.append("T_Distri_WaterChemicalSupplyID", T_Distri_WaterChemicalSupplyID);
        formdata.append("WaterReading", WaterReading);
    } else {
        formdata.append("T_WS_ChemicalSupplyID", T_WS_ChemicalSupplyID);
        formdata.append("Chroline", Chroline);
    }

    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'PATCH',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    let url
    if (DashProjectTypeId == '6' && RoleID != '16') {
        url = `${BaseUrl}/APKDashboard/Post_WEB_WS_T_Distri_WaterChemicalSupply_Update`
    } else {
        url = `${BaseUrl}/APKDashboard/Post_WEB_WS_T_WS_ChemicalSupply_Update`
    }

    fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleIsPost()
                // handleClearField()
                handleOnCloseClick()
                toastSuccesss(result.message)
                return result.data
            } else {
                toastErrorr(result.message)
            }
            return result
        })
})

const ChemicalSupplyPostDataSlice = createSlice({
    name: "ChemicalSupplyPostData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ChemicalSupplyPostDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(ChemicalSupplyPostDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(ChemicalSupplyPostDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const ChemicalSupplyPostDataReducer = ChemicalSupplyPostDataSlice.reducer

// -----------------Delete API ---------------

export const ChemicalSupplyDeleteAPI = createAsyncThunk("ChemicalSupplyDelete", async ({ data }) => {
    const {
        T_WS_ChemicalSupplyID,
        T_Distri_WaterChemicalSupplyID,
        M_UserID,
        token,
        handleIsPost,
        DashProjectTypeId,
        RoleID
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    if (DashProjectTypeId == '6' && RoleID != '16') {
        formdata.append("T_Distri_WaterChemicalSupplyID", T_Distri_WaterChemicalSupplyID);
    } else {
        formdata.append("T_WS_ChemicalSupplyID", T_WS_ChemicalSupplyID);
    }

    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    let url
    if (DashProjectTypeId == '6' && RoleID != '16') {
        url = `${BaseUrl}/APKDashboard/WEB_WS_T_Distri_WaterChemicalSupply_Delete`
    } else {
        url = `${BaseUrl}/APKDashboard/WEB_WS_T_WS_ChemicalSupply_Delete`
    }

    fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                toastSuccesss(result.message)
            } else {
                toastErrorr(result.message)

            }
            return result

        })
})

const ChemicalSupplyDeleteSlice = createSlice({
    name: "ChemicalSupplyDelete",
    initialState: {
        isDeleteLoading: false,
        SectorData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ChemicalSupplyDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(ChemicalSupplyDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.SectorData = action.payload;

        });
        builder.addCase(ChemicalSupplyDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.SectorData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const ChemicalSupplyDeleteReducer = ChemicalSupplyDeleteSlice.reducer